import { z } from 'zod';
import { requiredFieldError } from '../helper';

export const declareTaxableIncomeSchema = z.record(z.number().nonnegative(requiredFieldError('Annual taxable income')));

export const verifyIncomeConsentsSchema = z.record(
  z.literal(true, { errorMap: () => ({ message: 'Consent is required to continue' }) }),
);

export const verifyIncomeStatusSchema = z.record(
  z.literal(true, { errorMap: () => ({ message: 'Document verification must be completed before continuing' }) }),
);

export const landTitleEligibilityCheckSchema = z.object({
  declaredIncomes: declareTaxableIncomeSchema,
  consents: verifyIncomeConsentsSchema,
  verificationDone: verifyIncomeStatusSchema,
});

export type LandTitleEligibilityCheckType = z.infer<typeof landTitleEligibilityCheckSchema>;
